import classnames from 'classnames'
import { invoicePriceFormatter } from 'shared/utils'
import { CardSection } from '@components/CardSection'
import { DIGITAL_PASS_PRICE } from 'purchase-flow/constants'
import styles from 'purchase-flow/canada/components/styles.module.scss'

const DigitalAccessOption = ({ selectDeliveryRate, isSelected }) => (
    <CardSection
        activeSelected={isSelected}
        notActive
        className={classnames(styles.digitalAccessOptionCard, 'px-3', 'py-3', 'mt-3')}>
        <div className="d-sm-flex justify-content-between align-items-start" onClick={selectDeliveryRate}>
            <div>
                <div className="font-weight-bold text-large">
                    <T>subscription.purchase.accessOptions.digital.pass.label</T>
                </div>
                <div className="text-light">
                    <T>subscription.purchase.accessOptions.digital.pass.desc</T>
                </div>
            </div>
            <span className="font-weight-bold">{invoicePriceFormatter(DIGITAL_PASS_PRICE)}</span>
        </div>
    </CardSection>
)

export default DigitalAccessOption
